import { render, staticRenderFns } from "./EditPhoto.vue?vue&type=template&id=0601f088&"
import script from "./EditPhoto.vue?vue&type=script&lang=js&"
export * from "./EditPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports